import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Wrapper, Menu, MenuItem, Button } from 'react-aria-menubutton';
import styles from './Menu.css';
import { getRouteFor } from '../../routes';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  menu: PropTypes.array,
  history: PropTypes.object.isRequired,
};

const defaultProps = {
  menu: [],
};

const menuItems = menu => menu.map(item => (
  <li key={item.name}>
    <MenuItem value={item} className={styles['AriaMenuButton-menuItem']}>
      {item.name}
    </MenuItem>
  </li>
));

const handleSelection = (history, value, e) => {
  e.stopPropagation();
  if (value.type === 'route') {
    window.location.href = getRouteFor(value.action);
  } else {
    value.action();
  }
};

const MenuDropdown = ({ children, menu, history }) => (
  <Wrapper
    className={styles.AriaMenuButton}
    onSelection={(value, e) => handleSelection(history, value, e)}
  >
    <Button className={styles['AriaMenuButton-button']}>
      {children}
    </Button>
    <Menu className={styles['AriaMenuButton-menu']}>
      <ul className={styles['AriaMenuButton-menu-content']}>{menuItems(menu)}</ul>
    </Menu>
  </Wrapper>
);

MenuDropdown.propTypes = IPropTypes;
MenuDropdown.defaultProps = defaultProps;

const WrappedMenuDropdown = withRouter(MenuDropdown);

export { WrappedMenuDropdown as MenuDropdown };



// WEBPACK FOOTER //
// ./src/common/menu-dropdown/Menu.jsx